import { Fragment as _Fragment, jsx as _jsx } from "preact/jsx-runtime";
import { createPortal } from 'preact/compat';
const Notification = ({ message }) => {
    const container = document.querySelector('#PreactNotification');
    if (!message || !container) {
        return (_jsx(_Fragment, {}, void 0));
    }
    if (container === null) {
        return (_jsx(_Fragment, {}, void 0));
    }
    const Content = (_jsx("div", Object.assign({ className: "notification mb3" }, { children: message }), void 0));
    return createPortal(Content, container);
};
export default Notification;
